var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.3 28.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M15.7,28.3c4.4,0,8.4-2,11-5.2c0.4-0.5,0-1.2-0.6-1.1c-6.9,1.3-13.2-4-13.2-10.9c0-4,2.1-7.7,5.6-9.7 c0.5-0.3,0.4-1.1-0.2-1.2C17.4,0.1,16.5,0,15.7,0C7.9,0,1.5,6.3,1.5,14.2C1.5,22,7.8,28.3,15.7,28.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMoon);
export default __webpack_public_path__ + "static/media/dark-moon.c6719fcd582523d9af341e48151fa86b.svg";
export { ForwardRef as ReactComponent };